import React from "react";
import styled from "styled-components";
import Modal from "../Modal";
import SimpleBar from "simplebar-react";
import UserTree from "./UserTree";
import Button from "../Button";

const ModalTree = ({
  userId,
  userName,
  userLastname,
  onClose = () => {},
  courseId,
  episodeId,
  chapterId,
  lessonId,
}) => {
  return (
    <ModalStyled>
      <Content>
        <SimpleBar style={{ maxHeight: "70vh" }}>
          {userId && (
            <UserTree
              userId={userId}
              userName={userName}
              userLastname={userLastname}
              courseId={courseId}
              episodeId={episodeId}
              chapterId={chapterId}
              lessonId={lessonId}
            />
          )}
        </SimpleBar>
      </Content>
      <ButtonStyled secondary text="Cerrar" onClick={onClose} />
    </ModalStyled>
  );
};

const ModalStyled = styled(Modal)`
  max-width: 450px;
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 95%;
`;

const Content = styled.div`
  width: 100%;
`;

const ButtonStyled = styled(Button)`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export default ModalTree;
